// extracted by mini-css-extract-plugin
export var clauseRow = "_dw-6";
export var emptyState = "_dw-d";
export var filterContent = "_dw-a";
export var filterGroup = "_dw-1";
export var filterGroupContainer = "_dw-0";
export var nestedGroup = "_dw-2";
export var nestedGroupContent = "_dw-b";
export var nestedGroupDepth1 = "_dw-3";
export var nestedGroupDepth2 = "_dw-4";
export var nestedGroupDepth3 = "_dw-5";
export var nestedGroupEmpty = "_dw-c";
export var operatorAnd = "_dw-8";
export var operatorOr = "_dw-9";
export var operatorToggle = "_dw-7";
export var removeGroupButton = "_dw-e";